module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-54.b32452c0.svg";